import {
  useGlobalCurrency,
  useGlobalPeriod,
  useOverview,
  useSnapshot,
} from "@iliotech/data-wire";
import { ReportWidgetProps } from "../../ReportWidgetProps";
import { useParams } from "react-router-dom";
import SimpleTable, {
  SimpleTableColumnProps,
} from "src/components/SimpleTable/SimpleTable";
import { PortfolioOverviewV3 } from "@iliotech/generated-api-v3";
import s from "./OverviewTableWidget.module.scss";
import { observer } from "mobx-react-lite";
import classNames from "classnames";
export const OverviewTableWidget = observer(
  ({ periodContext, isHalfHeight }: ReportWidgetProps) => {
    const period = periodContext || useGlobalPeriod();
    const { portfolioId } = useParams();
    const { data: overview } = useOverview(portfolioId!, period);
    const { data: snapshot } = useSnapshot(
      portfolioId!,
      period.periodForRequest
    );
    const totalIncome = snapshot?.data?.reduce(
      (sum: number, item: any) => sum + (item.incomeHistoricBase ?? 0),
      0
    );
    const data: PortfolioOverviewV3 | undefined = overview?.data;
    const { currencyFormatter } = useGlobalCurrency();

    // Transform the data into rows
    const tableData = data
      ? [
          { label: "Opening Value", value: data.openingBalance },
          { label: "Net deposits", value: data.deposits },
          { label: "Withdrawals", value: data.withdrawals },
          { label: "Total Income", value: totalIncome },
          { label: "Realized Gains", value: data.realizedGains },
          { label: "Unrealized Gains", value: data.unrealizedGains },
          { label: "Closing Value", value: data.closingBalance },
          {
            label: "Portfolio Performance",
            value: data.portfolioPerformance,
            isPercentage: true,
          },
          {
            label: "Benchmark Performance",
            value: data.benchmarkPerformance,
            isPercentage: true,
          },
        ]
      : [];

    const renderCell = (props: any) => {
      const value = props.dataItem[props.field];
      const isPercentage = props.dataItem.isPercentage;

      return (
        <td style={{ textAlign: "right" }}>
          {isPercentage ? `${value.toFixed(2)}%` : currencyFormatter(value)}
        </td>
      );
    };

    const columns: SimpleTableColumnProps[] = [
      {
        field: "label",
        title: "",
        cell: (props: any) => <td>{props.dataItem[props.field]}</td>,
      },
      {
        field: "value",
        title: period.periodString,
        cell: renderCell,
        rightAligned: true,
      },
    ];

    return (
      <div className={classNames(isHalfHeight && s.halfHeight)}>
        <h6 className={"element-title"}>Portfolio Overview</h6>
        <p className={"period-string"}>{periodContext.periodString}</p>
        <div style={{ marginTop: "10px" }} />
        <SimpleTable
          data={tableData}
          columns={columns}
          sortable={false}
          reorderable={false}
        />
      </div>
    );
  }
);
